module.exports = __webpack_public_path__ + "static/img/Nature_Comeback_Logo.cc6d92b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Nature_Comeback_Logo.png
// module id = ocGV
// module chunks = 0